import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin } from 'lucide-react';
const names = ['Camila', 'Florencia', 'Luciana', 'Valeria', 'Mariana', 'Sofía', 'Martina', 'Valentina', 'Julieta', 'Agustina'];
const cities = ['Córdoba', 'Rosario', 'Buenos Aires', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Tucumán', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setCurrentPurchase({
        name: randomName,
        city: randomCity,
        time: `Hace ${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring
    const interval = setInterval(() => {
      showPopup();
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-209">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-2xl shadow-xl p-4 z-50 border border-emerald-100 flex items-center gap-4" data-id="element-210">
          <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-211">
            <span className="text-teal-700 font-bold text-lg" data-id="element-212">
              {currentPurchase.name.charAt(0)}
            </span>
          </div>
          <div className="flex-1" data-id="element-213">
            <p className="text-sm text-gray-800 font-medium" data-id="element-214">
              <span className="font-bold" data-id="element-215">{currentPurchase.name}</span> compró
            </p>
            <p className="text-xs text-teal-700 font-semibold" data-id="element-216">
              Gimnasia Postural Resuelta
            </p>
            <div className="flex items-center gap-1 mt-1 text-xs text-gray-500" data-id="element-217">
              <MapPin size={10} data-id="element-218" />
              <span data-id="element-219">
                {currentPurchase.city} • {currentPurchase.time}
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}